import classNames from "classnames";
import { FC, useCallback, useMemo } from "react";

import Modal from "components/Modal";

import { RootStore } from "store";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { removeDeviceRequest } from "store/slices/deviceSlice";

import ModalRemoveDeviceContent from "./Content";

import styles from "./styles.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  name?: string;
  devEui?: string;
};

const WidgetModalRemoveDevice: FC<PropTypes> = ({ isVisible, className, devEui }) => {
  const dispatch = useAppDispatch();
  const isRemoving = useAppSelector((state: RootStore) => state.devices.isRemoving);

  const handleDelete = useCallback(() => {
    if (!devEui) return;
    dispatch(removeDeviceRequest(devEui));
  }, [devEui, dispatch]);

  const title = useMemo(() => "Delete device", []);

  return (
    <Modal
      title={title}
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <ModalRemoveDeviceContent onConfirm={handleDelete} isLoading={isRemoving} />
    </Modal>
  );
};

export default WidgetModalRemoveDevice;
